module.exports = __webpack_public_path__ + "img/headerLogo.837a8170.png";